import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { BaseService } from 'src/app/_services/base.service';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class TaxReportService {

    constructor(private _bs: BaseService) { }

    /**
     * State-wise tax report via the unified report endpoint
     * (InventoryBaseURL + Reports/GetReport), same POST shape as SalesTaxReport.
     * `parameter` carries StartDate/EndDate (MM/dd/yyyy), LocationIds and OrderPlacement.
     */
    getTaxReport(parameter: any) {
        const url = environment.InventoryBaseURL + environment.Report;
        const body = { ReportName: 'TaxRateReport', Parameter: parameter };
        return this._bs.httpPost(url, JSON.stringify(body)).pipe(map((res: any) => res));
    }
}
